import React from 'react';
import '../styles/components/SymptomsSection.css';

const SymptomsSection = ({ formData, setFormData }) => {
  const symptoms = [
    { id: 'fatigue', label: '疲労感・だるさ', description: '慢性的な疲れや体のだるさ' },
    { id: 'cold', label: '冷え性', description: '手足の冷えや体温調節の困難' },
    { id: 'irritability', label: 'イライラ・気分の変動', description: '感情の起伏や精神的な不安定さ' },
    { id: 'swelling', label: 'むくみ', description: '顔や手足のむくみ' },
    { id: 'weight_gain', label: '体重増加', description: '食事量に関係ない体重の増加' },
    { id: 'hair_loss', label: '抜け毛・薄毛', description: '髪の毛が抜けやすい、薄くなった' },
    { id: 'skin_dryness', label: '肌の乾燥', description: '肌がカサカサする、かゆみがある' },
    { id: 'constipation', label: '便秘', description: '排便が困難、お腹の張り' },
    { id: 'concentration', label: '集中力の低下', description: '物忘れが増えた、集中できない' },
    { id: 'sleep_disorder', label: '睡眠障害', description: '寝つきが悪い、眠りが浅い' },
    { id: 'menstrual', label: '月経異常', description: '生理不順、生理痛の悪化（女性の方）' },
    { id: 'muscle_pain', label: '筋肉痛・関節痛', description: '体の痛みやこわばり' }
  ];

  const handleSymptomChange = (symptomId, checked) => {
    setFormData(prev => ({
      ...prev,
      symptoms: {
        ...prev.symptoms,
        [symptomId]: checked
      }
    }));
  };

  const handleSeverityChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      symptoms: {
        ...prev.symptoms,
        [field]: value
      }
    }));
  };

  return (
    <div className="symptoms-section">
      <h3 className="tsumugi-card-title">💊 現在の症状（任意）</h3>
      <p className="symptoms-section__hint">
        当てはまるものだけチェックしてください
      </p>

      {/* 症状チェックボックス */}
      <div className="symptoms-section__grid">
        {symptoms.map((symptom) => (
          <label key={symptom.id} className="profile-edit-checkbox-label">
            <input
              type="checkbox"
              checked={formData.symptoms?.[symptom.id] || false}
              onChange={(e) => handleSymptomChange(symptom.id, e.target.checked)}
              className="profile-edit-checkbox"
            />
            <span className="symptoms-section__label-text">{symptom.label}</span>
            <span className="symptoms-section__description">
              {symptom.description}
            </span>
          </label>
        ))}
      </div>

      {/* 症状の程度 */}
      <div className="symptoms-section__severity">
        <h4 className="symptoms-section__severity-title">
          症状の程度
        </h4>

        <div className="symptoms-section__severity-grid">
          <div>
            <label className="profile-edit-label">
              症状の重さ
            </label>
            <select
              className="profile-edit-select"
              value={formData.symptoms?.severity || ''}
              onChange={(e) => handleSeverityChange('severity', e.target.value)}
            >
              <option value="">選択</option>
              <option value="mild">軽度</option>
              <option value="moderate">中程度</option>
              <option value="severe">重度</option>
            </select>
          </div>

          <div>
            <label className="profile-edit-label">
              継続期間
            </label>
            <select
              className="profile-edit-select"
              value={formData.symptoms?.duration || ''}
              onChange={(e) => handleSeverityChange('duration', e.target.value)}
            >
              <option value="">選択</option>
              <option value="recent">1ヶ月以内</option>
              <option value="short">1〜6ヶ月</option>
              <option value="medium">6ヶ月〜2年</option>
              <option value="long">2年以上</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SymptomsSection;